import { useParams } from 'react-router-dom';
import SideBar from '../../components/global/SideBar';
import './index.css';
import { ClassProfile } from '@beholos/holoscommon';

export default function ClassProfilePage() {
  const { partnerSlug, classSlug, timeStamp } = useParams();

  // Guard against undefined params
  if (!partnerSlug || !classSlug || !timeStamp) {
    return <div>Invalid class parameters</div>;
  }

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-sand">
        <ClassProfile 
          partnerSlug={partnerSlug} 
          classSlug={classSlug} 
          timestamp={Number(timeStamp)} 
          isLoggedIn={true}
        />
      </div>
    </div>
  );
}
